import * as React from "react";
import type { SVGProps } from "react";
const SvgGear = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.778 15.326a4 4 0 1 0 4.444-6.652 4 4 0 0 0-4.444 6.652Zm1.11-4.989a2 2 0 1 1 2.223 3.325 2 2 0 0 1-2.222-3.325Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.31 21.424A2.7 2.7 0 0 0 12 22a2.7 2.7 0 0 0 2.65-2.08.599.599 0 0 1 .08-.21.73.73 0 0 1 1-.24 2.72 2.72 0 0 0 3.74-3.74.599.599 0 0 1-.08-.21.71.71 0 0 1 .53-.87 2.73 2.73 0 0 0 0-5.3.6.6 0 0 1-.21-.08.74.74 0 0 1-.24-1 2.72 2.72 0 0 0-3.74-3.74 1 1 0 0 1-.21.09.72.72 0 0 1-.87-.54 2.73 2.73 0 0 0-5.3 0 .71.71 0 0 1-.756.554.73.73 0 0 1-.324-.104 2.67 2.67 0 0 0-3.34.4 2.67 2.67 0 0 0-.4 3.34.6.6 0 0 1 .08.21.71.71 0 0 1-.53.87 2.73 2.73 0 0 0 0 5.3c.074.013.146.04.21.08a.74.74 0 0 1 .24 1 2.67 2.67 0 0 0 .4 3.34 2.67 2.67 0 0 0 3.34.4c.066-.038.137-.068.21-.09a.72.72 0 0 1 .87.54 2.7 2.7 0 0 0 .96 1.504Zm.025-3.475a2.74 2.74 0 0 0-1.685-.589c-.22.001-.437.028-.65.08a3.13 3.13 0 0 0-.75.32.72.72 0 0 1-1-1 2.73 2.73 0 0 0-.91-3.75 2.998 2.998 0 0 0-.78-.32.72.72 0 0 1 0-1.4 2.74 2.74 0 0 0 2-3.29 3 3 0 0 0-.33-.76.72.72 0 0 1 1-1 2.73 2.73 0 0 0 4.06-1.67.72.72 0 0 1 1.4 0 2.74 2.74 0 0 0 3.29 2 3.13 3.13 0 0 0 .78-.32.72.72 0 0 1 1 1 2.73 2.73 0 0 0 .91 3.75c.245.132.508.23.78.29a.72.72 0 0 1 0 1.4 2.74 2.74 0 0 0-2 3.29c.07.274.177.536.32.78a.72.72 0 0 1-1 1 2.74 2.74 0 0 0-3.75.91c-.143.244-.25.506-.32.78a.72.72 0 0 1-1.4 0 2.74 2.74 0 0 0-.965-1.501Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgGear;
